import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import type { Query } from '@tanstack/react-query';

import {
  GET_AI_AGENT_CATEGORIES_QUERY,
  GET_AI_AGENT_SUITES_QUERY,
  GET_AI_AGENTS_QUERY,
  GET_AVAILABLE_INTEGRATIONS_QUERY,
} from '@/utils/query-keys';

const PERSIST_KEY = 'agentous.rq.public.v1';

const noopStorage: Storage = {
  length: 0,
  clear: () => undefined,
  getItem: () => null,
  key: () => null,
  removeItem: () => undefined,
  setItem: () => undefined,
};

const storage =
  typeof window !== 'undefined' && window.sessionStorage
    ? window.sessionStorage
    : noopStorage;

export const queryPersister = createSyncStoragePersister({
  storage,
  key: PERSIST_KEY,
  // sessionStorage caps at ~5 MB; throttle writes so a flurry of
  // query updates doesn't stall the main thread.
  throttleTime: 1000,
});

// Only persist the public catalog queries — auth, tenant, and dashboard data
// are scoped to the in-memory cache and revalidated normally.
const PERSISTED_KEYS: ReadonlySet<string> = new Set([
  GET_AI_AGENTS_QUERY,
  GET_AI_AGENT_SUITES_QUERY,
  GET_AI_AGENT_CATEGORIES_QUERY,
  GET_AVAILABLE_INTEGRATIONS_QUERY,
]);

export const shouldPersistQuery = (query: Query): boolean => {
  const [head] = query.queryKey;
  return typeof head === 'string' && PERSISTED_KEYS.has(head);
};
